import { useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import { GoThumbsup } from 'react-icons/go'
import { device } from '../../breakpoints'

const AnimatedImage = ({
  src,
  strength,
  text,
}: {
  src?: string
  strength: number
  text: string
}) => {
  const [containerRef, setContainerRef] = useState<HTMLDivElement | null>(null)
  const [textContainerRef, setTextContainerRef] = useState<HTMLDivElement | null>(null)
  const observer = useRef<IntersectionObserver | null>(null)

  const handleScroll = () => {
    if (!containerRef || !textContainerRef) return
    const pct = Math.max(0, Math.min(1, (containerRef.getBoundingClientRect().top / window.innerHeight) * 2))

    containerRef.style.setProperty(
      'background-position',
      `50% calc(25% + ${pct * 100 * 0.25}%)`
    )

    textContainerRef.style.setProperty(
      'transform',
      `translateY(${(containerRef.getBoundingClientRect().top) * 0.75}px)`
    )
  }

  useEffect(() => {
    if (!containerRef) return

    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', handleScroll)
        } else {
          window.removeEventListener('scroll', handleScroll)
        }
      })
    }

    let options = {
      rootMargin: '0px',
      threshold: 0,
    }

    observer.current = new IntersectionObserver(handleIntersection, options)
    // observer.current.observe(containerRef as Element)
  }, [containerRef])

  return (
    <Container
      ref={setContainerRef}
      style={
        src
          ? { backgroundImage: `url(${src})` }
          : { backgroundColor: '#000' }
      }
    >
      <Text ref={setTextContainerRef}><GoThumbsup /></Text>
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  background-size: cover;
  background-position: center;

  &:after {
    content: '';
    display: block;
    padding-bottom: 75%;

    @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
      padding-bottom: 75%;
    }
  
    @media ${device.tablet}, @media ${device.laptop} {
      padding-bottom: 75%;
    }
  }
`

const Text = styled.div`
font-size: 2em;
color: var(--text-color);
margin-left: 15px;
line-height: 1;
background-color: #ffffff;
border-radius: 90px;
display: inline-block;
padding: 10px;
display: none;
`

export default AnimatedImage
